<!--
 * @Author: vince
 * @Date: 2021-08-16 13:40:47
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2021-12-30 16:59:00
 * @Description:
-->
<template>
  <div>
    <div class="state-bar pa-md mb-md">
      <el-row class="full-width">
        <el-col :span="4">
          <el-popconfirm title="确定放弃修改？" @confirm="$router.go(-1)">
            <el-button slot="reference">取消</el-button>
          </el-popconfirm>
        </el-col>
        <el-col :span="8" :offset="4">
          <div class="full-width" style="display: block">
            <el-steps :active="active" align-center>
              <el-step>
                <template v-slot:title>
                  <el-button @click="active = 0" type="text"
                    >基本信息</el-button
                  >
                </template>
              </el-step>
              <el-step>
                <template v-slot:title>
                  <el-button @click="active = 1" type="text"
                    >教学设计</el-button
                  >
                </template>
              </el-step>
            </el-steps>
          </div>
        </el-col>
        <el-col :span="4" :offset="4" class="text-right">
          <el-button type="primary" icon="el-icon-upload2" @click="onPublish"
            >发布</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="content-box pa-md bg-white">
      <el-tabs :value="currentTab" class="no-tab">
        <el-tab-pane name="0">
          <el-form
            :model="baseInfo"
            ref="baseInfo"
            :rules="baseInfoRules"
            label-width="200px"
          >
            <el-form-item label="学科" prop="disciplineTemp">
              <el-select
                v-model="baseInfo.disciplineTemp"
                @change="disciplineChange"
                placeholder="请选择学科"
                size="small"
                value-key="disciplineCode"
              >
                <el-option
                  v-for="item in options"
                  :label="item.disciplineName"
                  :value="item"
                  :key="item.disciplineCode"
                ></el-option
              ></el-select>
            </el-form-item>
            <el-form-item label="教材版本" prop="bookVsn" v-if="isShow">
              <el-input
                v-model="baseInfo.bookVsn"
                size="small"
                placeholder="请输入教材版本"
              ></el-input>
              <!-- <dicSelector dicType="textbook-version" v-model="baseInfo.bookVsnTemp"></dicSelector> -->
            </el-form-item>
            <el-form-item label="年级/册" prop="gradeTermTemp">
              <grade-term-selector
                v-model="baseInfo.gradeTermTemp"
              ></grade-term-selector>
            </el-form-item>
            <el-form-item label="单元" prop="unit" v-if="isShow">
              <el-input
                size="small"
                show-word-limit
                maxlength="10"
                v-model="baseInfo.unit"
                placeholder="请输入单元"
              ></el-input>
            </el-form-item>
            <el-form-item label="作者" prop="otherAuthor">
              <author-selector v-model="baseInfo.otherAuthor"></author-selector>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="onNextStep"
                >下一步 填写教学设计</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="1">
          <!-- :rules="articleRules" -->
          <el-form
            :model="article"
            ref="article"
            :rules="articleRules"
            label-width="150px"
          >
            <el-form-item label="标题" prop="title">
              <el-input
                class
                v-model="article.title"
                show-word-limit
                maxlength="20"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="课时" prop="period">
              <el-input
                v-model="article.period"
                show-word-limit
                maxlength="10"
                placeholder="请输入课时"
              ></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="classify">
              <el-input
                v-model="article.classify"
                placeholder="请输入类型"
                show-word-limit
                maxlength="10"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="录播课系统资源外链"
              prop="link"
              placeholder="请输入录播课系统资源外链地址"
            >
              <el-input
                v-model="article.link"
                show-word-limit
                maxlength="100"
              ></el-input>
            </el-form-item>
            <el-form-item label="教学设计文件" prop="designAttachList">
              <uploader
                multiple
                accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                listType="text"
                :maxSize="1 * 1024 * 1024 * 1024"
                :file-list.sync="article.designAttachList"
                tipDesc="请上传word文档"
              />
            </el-form-item>
            <el-form-item label="教学反思文件" prop="rethinkAttachList">
              <uploader
                multiple
                accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                listType="text"
                :maxSize="1 * 1024 * 1024 * 1024"
                tipDesc="请上传word文档"
                :file-list.sync="article.rethinkAttachList"
              />
            </el-form-item>
            <el-form-item label="资源文件">
              <uploader
                multiple
                accept="*"
                listType="text"
                :maxSize="1 * 1024 * 1024 * 1024"
                :file-list.sync="article.sourceAttachList"
              />
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="onPreStep"
                >上一步 填写基本信息</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AuthorSelector from '../../components/school/authorSelector.vue'
import dicSelector from '../../components/school/dicSelector.vue'
import Discipline from '../../components/school/disciplineSelector.vue'
import GradeTermSelector from '../../components/school/grade&TermSelector.vue'
import uploader from '../../components/school/uploader.vue'
import { postData, postJson } from '../../http/fetch'
export default {
  name: 'teachingDesignAdd',
  components: {
    Discipline,
    dicSelector,
    GradeTermSelector,
    AuthorSelector,
    uploader
  },
  props: {
    id: {
      type: Number | String
    }
  },
  data() {
    var validatorDesignAttachList = (rule, value, callback) => {
      if (
        this.article.designAttachList.length > 0 &&
        this.article.designAttachList.some((i) =>
          ['doc', 'docx'].includes(i.attachType)
        )
      ) {
        callback()
      } else {
        return callback(
          new Error('请上传教学设计文件且必须存在doc,docx类型的文件')
        )
      }
    }
    var validatorRethinkAttachList = (rule, value, callback) => {
      if (
        this.article.rethinkAttachList.length > 0 &&
        this.article.rethinkAttachList.some((i) =>
          ['doc', 'docx'].includes(i.attachType)
        )
      ) {
        callback()
      } else {
        return callback(
          new Error('请上传教学反思文件且必须存在doc,docx类型的文件')
        )
      }
    }
    var validatorLink = (rule, value, callback) => {
      if (
        (this.article.link.length > 0 && this.isURL(this.article.link)) ||
        this.article.link.length == 0
      ) {
        callback()
      } else {
        return callback(new Error('请输入正确的录播课资源外链'))
      }
    }
    return {
      loading: false,
      active: 0,
      fileList: [],
      options: [],
      baseInfo: {
        id: '',
        infoCode: '',
        typeState: null,
        disciplineTemp: null,
        bookVsnTemp: null,
        gradeTermTemp: null,
        disciplineCode: '',
        disciplineName: '',
        bookVsn: '',
        bookDesc: '',
        grade: '',
        gradeName: '',
        term: '',
        unit: '',
        otherAuthor: [],
        signatureType: ''
      },
      article: {
        title: '',
        period: '',
        classify: '',
        link: '',
        designAttachList: [],
        rethinkAttachList: [], //教学反思文件
        sourceAttachList: []
      },
      baseInfoRules: {
        disciplineTemp: {
          required: true,
          message: '请选择学科',
          trigger: 'change'
        },
        bookVsn: {
          required: true,
          message: '请选择教材版本',
          trigger: 'change'
        },
        gradeTermTemp: {
          required: true,
          message: '请选择年级/册',
          trigger: 'change'
        },
        unit: { required: true, message: '请输入单元', trigger: 'change' },
        otherAuthor: {
          required: true,
          message: '请选择作者',
          trigger: 'change'
        }
      },
      articleRules: {
        title: { required: true, message: '请输入标题', trigger: 'blur' },
        classify: { required: true, message: '请输入类型', trigger: 'blur' },
        period: { required: true, message: '请输入课时', trigger: 'blur' },
        designAttachList: {
          validator: validatorDesignAttachList,
          required: true,
          trigger: 'change'
        },
        rethinkAttachList: {
          validator: validatorRethinkAttachList,
          required: true,
          trigger: 'change'
        },
        link: {
          validator: validatorLink,
          required: false,
          trigger: 'change'
        }
      }
    }
  },
  computed: {
    currentTab() {
      return `${this.active}`
    },
    ...mapState(['userInfo']),
    ...mapGetters(['operatorId', 'schoolCode']),
    isShow() {
      return this.baseInfo.typeState !== 6
    }
  },
  mounted() {
    this.getDisciplinelList()
    if (this.id) {
      this.getData()
    } else {
      this.baseInfo.otherAuthor = [
        {
          schoolCode: this.schoolCode,
          userId: this.operatorId,
          userName: this.userInfo.userName
        }
      ]
    }
  },
  methods: {
    async getDisciplinelList() {
      postData('/discipline/getDisciplinelList', {
        schoolCode: this.schoolCode
      }).then((res) => {
        console.log(res)
        this.options = res
      })
    },
    disciplineChange(val) {
      this.baseInfo.typeState = val.typeState
    },
    isURL(strUrl) {
      var regular =
        /^\b(((https?|ftp):\/\/)?[-a-z0-9]+(\.[-a-z0-9]+)*\.(?:com|edu|gov|int|mil|net|org|biz|info|name|museum|asia|coop|aero|[a-z][a-z]|((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d))\b(\/[-a-z0-9_:\@&?=+,.!\/~%\$]*)?)$/i
      if (regular.test(strUrl)) {
        return true
      } else {
        return false
      }
    },
    onPreStep() {
      this.active = 0
    },
    onNextStep() {
      this.active = 1
    },
    resetForm() {
      this.$refs.baseInfo.resetFields()
      this.$refs.article.resetFields()
    },
    getData() {
      this.loading = true
      postData('/teacherDesignInfoController/getTeacherDesign', {
        id: this.id,
        operatorId: this.operatorId
      })
        .then((res) => {
          this.baseInfo.infoCode = res.infoCode
          this.baseInfo.disciplineTemp = {
            disciplineCode: res.disciplineCode,
            disciplineName: res.disciplineName
          }
          this.baseInfo.typeState = res.typeState
          this.baseInfo.id = res.id
          this.baseInfo.infoCode = res.infoCode
          this.baseInfo.disciplineCode = res.disciplineCode
          this.baseInfo.disciplineName = res.disciplineName

          // this.baseInfo.bookVsnTemp = {
          // 	dicName: res.bookDesc,
          // 	dicCode: res.bookVsn
          // };
          this.baseInfo.bookVsn = res.bookVsn
          this.baseInfo.bookDesc = res.bookDesc

          this.baseInfo.gradeTermTemp = {
            grade: {
              value: res.grade,
              label: res.gradeName
            },
            value: [res.grade, res.term]
          }

          this.baseInfo.grade = res.grade
          this.baseInfo.gradeName = res.gradeName
          this.baseInfo.term = res.term
          this.baseInfo.unit = res.unit

          this.article.link = res.link
          this.article.title = res.title
          this.article.period = res.period
          this.article.classify = res.classify

          if (res.designAttachList.length) {
            this.article.designAttachList = res.designAttachList.map((m) => {
              m.name = m.attachUrl
              m.status = 'success'
              return m
            })
          }
          if (res.rethinkAttachList.length) {
            this.article.rethinkAttachList = res.rethinkAttachList.map((m) => {
              m.name = m.attachUrl
              m.status = 'success'
              return m
            })
          }
          if (res.sourceAttachList.length) {
            this.article.sourceAttachList = res.sourceAttachList.map((m) => {
              m.name = m.attachUrl
              m.status = 'success'
              return m
            })
          }

          let otherAuthor = JSON.parse(res.otherAuthor)
          this.baseInfo.otherAuthor = otherAuthor.map((m) => {
            if (m.schoolCode) {
              return m
            } else {
              return m.userId
            }
          })
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onPublish() {
      await this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          return true
        } else {
          this.active = 0
          return false
        }
      })
      await this.$refs.article.validate((vld) => {
        if (vld) {
          postJson(
            'teacherDesignInfoController/saveOrUpdateTeacherDesignInfo',
            {
              bookDesc: this.baseInfo.bookVsn,
              bookVsn: this.baseInfo.bookVsn,
              classify: this.article.classify,
              designAttachList: this.article.designAttachList.length
                ? this.article.designAttachList.map((m) => {
                    return {
                      attachSize: m.attachSize,
                      attachType: m.attachType,
                      attachUrl: m.attachUrl,
                      attachName: m.attachName
                    }
                  })
                : [],
              rethinkAttachList: this.article.rethinkAttachList.length
                ? this.article.rethinkAttachList.map((m) => {
                    return {
                      attachSize: m.attachSize,
                      attachType: m.attachType,
                      attachUrl: m.attachUrl,
                      attachName: m.attachName
                    }
                  })
                : [],
              disciplineCode: this.baseInfo.disciplineTemp.disciplineCode,
              disciplineName: this.baseInfo.disciplineTemp.disciplineName,
              typeState: this.baseInfo.typeState,
              grade: this.baseInfo.gradeTermTemp.grade.value,
              gradeName: this.baseInfo.gradeTermTemp.grade.label,
              id: this.baseInfo.id ? this.id : null,
              infoCode: this.baseInfo.infoCode ? this.baseInfo.infoCode : null,
              // "infoCode": "",
              isOnline: 1,
              link: this.article.link,
              operatorId: this.operatorId,
              otherAuthor: this.baseInfo.otherAuthor.length
                ? JSON.stringify(
                    this.baseInfo.otherAuthor.map((m) => {
                      if (typeof m == 'string') {
                        return {
                          userId: m,
                          schoolCode: null,
                          userName: m
                        }
                      } else {
                        return {
                          userId: m.userId,
                          schoolCode: m.schoolCode,
                          userName: m.userName
                        }
                      }
                    })
                  )
                : '',
              period: this.article.period,
              schoolCode: this.schoolCode,
              sourceAttachList: this.article.sourceAttachList.length
                ? this.article.sourceAttachList.map((m) => {
                    return {
                      attachSize: m.attachSize,
                      attachType: m.attachType,
                      attachUrl: m.attachUrl,
                      attachName: m.attachName
                    }
                  })
                : [],
              term: this.baseInfo.gradeTermTemp.value[1],
              title: this.article.title,
              unit: this.baseInfo.unit,
              schoolCode: this.schoolCode
            }
          )
            .then((res) => {
              this.$message.success('发布成功！')
              this.$router.push({ name: 'teachingDesign' })
            })
            .catch((e) => {
              this.$message.error('发布失败！')
            })
        } else {
          this.active = 1
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.uploader {
  display: inline-block;
}
</style>


